// Validation check fields for ApplicationRoleAttribute
export const validationCheckFields = [
    // { key: 'validation_ActionType', labelKey: 'ActionType' },
    // {
    //     key: 'validation_ApplicationRole',
    //     labelKey: 'ApplicationRole',
    // },
    // {
    //     key: 'validation_AccountStore',
    //     labelKey: 'AccountStore',
    // },
    // {
    //     key: 'validation_EligibilityType',
    //     labelKey: 'EligibilityType',
    // },
    // {
    //     key: 'validation_AssigneeType',
    //     labelKey: 'AssigneeType',
    // },
    // {
    //     key: 'validation_Assignee',
    //     labelKey: 'Assignee',
    // },
    // { key: 'validation_AssignmentExists', labelKey: 'AssignmentExists' },
]

